// extracted by mini-css-extract-plugin
export default {"titleName":"InfoBoxTitle_titleName__O12m7","activeColor":"InfoBoxTitle_activeColor__p4tpC"};